<div
  class="vendor-contractor-headcount clickable"
  role="button"
  tabindex="0"
  title="View contractors list"
  (click)="navigateToContractorsList()"
  (keydown.enter)="navigateToContractorsList()"
  (keydown.space)="navigateToContractorsList(); $event.preventDefault()"
>
  <div class="ch-head">
    <div class="ch-title">
      <span class="hdr-ic"><i class="material-icons">groups</i></span>
      <h2>Contractors Headcount</h2>
      <i class="material-icons ch-arrow">chevron_right</i>
    </div>
    <div class="ch-tools" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <select class="native-month" aria-label="Month" (change)="valueSelect($any($event.target).value)">
        <option *ngFor="let opt of month" [value]="opt.value" [selected]="opt.selected">{{ opt.label }}</option>
      </select>
    </div>
  </div>

  <div class="hc-body">
    <div class="hc-total">
      <span class="v">{{ totalContractor }}</span>
      <span class="lab">Total<br />contractors</span>
    </div>
    <div class="hc-split">
      <div class="hc-stat">
        <span class="dot on"></span>
        <div class="hc-stat-txt">
          <span class="n">{{ contractorOnBoarded }}</span>
          <span class="k">On-boarded</span>
        </div>
      </div>
      <div class="hc-stat">
        <span class="dot off"></span>
        <div class="hc-stat-txt">
          <span class="n">{{ contractorOffBoarded }}</span>
          <span class="k">Off-boarded</span>
        </div>
      </div>
    </div>
  </div>

  <div class="hcbar">
    <i [style.width.%]="onboardedPct" style="background:#17a06a"></i>
    <i [style.width.%]="offboardedPct" style="background:#93a0aa"></i>
  </div>
</div>
